import snsAxiosClient from '../common/http/http-sns';
import formatString from '../utils/formatString';
import { get } from 'lodash';

type AddressInfoType = {
  address1: string;
  address2?: string;
  zipCode: string;
  city: string;
  state: string;
  purposes: { name: string }[];
  addressType: { name: string };
};

function postValidateAddress(environmentVariables, user, addressInfo: AddressInfoType) {
  const options = {
    headers: {
      ...get(environmentVariables, 'UCA_VALIDATION_API_HEADERS_POST_V3'),
      Authorization: `Bearer ${get(user, 'authToken')}`,
    },
  };

  return snsAxiosClient(options).post(
    formatString(get(environmentVariables, 'SNS_VALIDATE_ADDRESS', 'validate_address'), {
      UUID: get(user, 'UUID'),
    }),
    addressInfo,
  );
}

export default postValidateAddress;
